// This file is automatically generated. Do not edit manually.

import { SafetyControlSurveyType } from "src/api/generated/erp/db/types/enums/safetyControlSurveyType";
import { makeAxiosRequest } from "src/api/utils/apiClient";
import { t } from "i18next";

export namespace SafetyControlSurveyLineApi {
	export async function getLines(args: {
		safetyControlSurveyId: number;
	}): Promise<Array<SafetyControlSurveyLineApi_SurveyLineWithQuestion>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/safetyControl/surveyLines/getLines",
			method: "POST",
			data: {
				safetyControlSurveyId: args.safetyControlSurveyId,
			},
		});
		return response as Array<SafetyControlSurveyLineApi_SurveyLineWithQuestion>;
	}

	export async function incrementCount(args: {
		safetyControlSurveyLineId: number;
		answerType: SafetyControlSurveyLineApi_AnswerType;
	}): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/safetyControl/surveyLines/incrementCount",
			method: "POST",
			data: {
				safetyControlSurveyLineId: args.safetyControlSurveyLineId,
				answerType: args.answerType,
			},
		});
		return response as void;
	}

	export async function decrementCount(args: {
		safetyControlSurveyLineId: number;
		answerType: SafetyControlSurveyLineApi_AnswerType;
	}): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/safetyControl/surveyLines/decrementCount",
			method: "POST",
			data: {
				safetyControlSurveyLineId: args.safetyControlSurveyLineId,
				answerType: args.answerType,
			},
		});
		return response as void;
	}

	export async function getQuestions(args: {
		surveyType: SafetyControlSurveyType;
	}): Promise<Array<SafetyControlSurveyLineApi_QuestionDto>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/safetyControl/surveyLines/getQuestions",
			method: "POST",
			data: {
				surveyType: args.surveyType,
			},
		});
		return response as Array<SafetyControlSurveyLineApi_QuestionDto>;
	}
}

export const SafetyControlSurveyLineApi_AnswerTypeValues = ["RIGHT", "WRONG"] as const;

export type SafetyControlSurveyLineApi_AnswerType = (typeof SafetyControlSurveyLineApi_AnswerTypeValues)[number];

export const getSafetyControlSurveyLineApi_AnswerTypeLabels = () => ({
	RIGHT: t("right"),
	WRONG: t("wrong"),
});

export const getSafetyControlSurveyLineApi_AnswerTypeLabel = (value: SafetyControlSurveyLineApi_AnswerType): string => {
	return getSafetyControlSurveyLineApi_AnswerTypeLabels()[value];
};

export interface SafetyControlSurveyLineApi_SurveyLineWithQuestion {
	groupName: string | null | undefined;
	questionId: number;
	questionText: string;
	rightAnswerCount: number;
	safetyControlSurveyLineId: number;
	wrongAnswerCount: number;
}

export interface SafetyControlSurveyLineApi_QuestionDto {
	groupName: string | null | undefined;
	index: number;
	question: string;
}
